import React from 'react';
import { useNavigate } from 'react-router-dom';

function NotFound() {
    const navigate = useNavigate();

    return (
        <main className="auth-cover-wrapper">
            <div className="auth-cover-content-inner">
                <div className="auth-cover-content-wrapper text-center">
                    <div className="auth-img">
                        <img
                            src="/assets/images/auth/auth-cover-404-bg.svg"
                            alt=""
                            className="img-fluid"
                        />
                    </div>
                </div>
            </div>

            <div className="auth-cover-sidebar-inner" dir="rtl">
                <div className="auth-cover-card-wrapper">
                    <div className="auth-cover-card p-sm-5" style={{ textAlign: 'right' }}>
                        <div className="wd-50 mb-5 mx-auto">
                            <img
                                src="/assets/images/redesigned.png"
                                alt="لوگو"
                                className="img-fluid"
                            />
                        </div>

                        <h4 className="fw-bold mb-2">صفحه پیدا نشد</h4>
                        <p className="fs-12 fw-medium text-muted">
                            متأسفیم، صفحه‌ای که دنبال آن می‌گردید وجود ندارد. لطفاً آدرس را بررسی کنید یا به صفحه دیگری در سایت ما بروید.
                        </p>

                        <h2 className="fw-bolder mb-4 text-center" style={{ fontSize: '120px', lineHeight: 1 }}>
                            4<span className="text-danger">0</span>4
                        </h2>

                        <div className="mt-3">
                            <button
                                className="btn btn-light-brand w-100"
                                onClick={() => navigate('/')}
                            >
                                بازگشت به صفحه اصلی
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default NotFound;
